import {toLonLat} from 'ol/proj';
import * as ser from './modules/series.js';

// Ouvrir le panneau latéral
document.getElementById("openNavButton").addEventListener("click", () => {
  document.getElementById("mySidenav").style.width = "250px";
  document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
});

// Fermer le panneau latéral
document.getElementById("closeNavButton").addEventListener("click", () => {
  document.getElementById("mySidenav").style.width = "0";
  document.body.style.backgroundColor = "white";
});

var series = new ser.Time_Series();

series.init_with_cookies();

series.map.on('click', function(evt){
  //alert(evt.pixel);
  //alert(map.getPixelFromCoordinate(evt.coordinate));
  //alert(toLonLat(evt.coordinate));
  var coords = toLonLat(evt.coordinate);
  var lat = coords[1];
  var lon = coords[0];
  series.cre_cook('series_lat',lat);
  series.cre_cook('series_lon',lon);
  series.get_data(lat,lon);
});

series.map.on('moveend', function(e) {
  series.cre_cook('series_zoom',series.map.getView().getZoom());
});

// Sync model menues
document.getElementById('id_model_side').addEventListener('change', (event) => {
  var ind=document.getElementById('id_model_side').selectedIndex;
  document.getElementById('id_model').selectedIndex=ind;
  series.cre_cook('series_model_index',ind);
  series.update_var(ind);
});
document.getElementById('id_model').addEventListener('change', (event) => {
  var ind=document.getElementById('id_model').selectedIndex;
  document.getElementById('id_model_side').selectedIndex=ind;
  series.cre_cook('series_model_index',ind);
  series.update_var(ind);
});
// Sync var menues
document.getElementById('id_var_side').addEventListener('change', (event) => {
  var ind=document.getElementById('id_var_side').selectedIndex;
  document.getElementById('id_var').selectedIndex=ind;
  var model=document.getElementById('id_model').value;
  series.cre_cook('series_'+model+'_var_index',ind);
});
document.getElementById('id_var').addEventListener('change', (event) => {
  var ind=document.getElementById('id_var').selectedIndex;
  document.getElementById('id_var_side').selectedIndex=ind;
  var model=document.getElementById('id_model').value;
  series.cre_cook('series_'+model+'_var_index',ind);
});
// Sync start menues
document.getElementById('id_start_side').addEventListener('change', (event) => {
  var ind=document.getElementById('id_start_side').selectedIndex;
  document.getElementById('id_start').selectedIndex=ind;
  series.cre_cook('series_start_index',ind);
});
document.getElementById('id_start').addEventListener('change', (event) => {
  var ind=document.getElementById('id_start').selectedIndex;
  document.getElementById('id_start_side').selectedIndex=ind;
  series.cre_cook('series_start_index',ind);
});
// Sync end menues
document.getElementById('id_end_side').addEventListener('change', (event) => {
  var ind=document.getElementById('id_end_side').selectedIndex;
  document.getElementById('id_end').selectedIndex=ind;
  series.cre_cook('series_end_index',ind);
});
document.getElementById('id_end').addEventListener('change', (event) => {
  var ind=document.getElementById('id_end').selectedIndex;
  document.getElementById('id_end_side').selectedIndex=ind;
  series.cre_cook('series_end_index',ind);
});
// Sync delta menues
document.getElementById('id_delta_side').addEventListener('change', (event) => {
  var ind=document.getElementById('id_delta_side').selectedIndex;
  document.getElementById('id_delta').selectedIndex=ind;
  series.cre_cook('series_delta_index',ind);
});
document.getElementById('id_delta').addEventListener('change', (event) => {
  var ind=document.getElementById('id_delta').selectedIndex;
  document.getElementById('id_delta_side').selectedIndex=ind;
  series.cre_cook('series_delta_index',ind);
});

window.APP_VERSION = process.env.GIT_VERSION || 'dev';
